import type { EntityViewType } from "@config";
import "../styles/index.scss";
import type { FullScreenProps } from "../types";

export const FullscreenView = ({
  entity,
  children,
}: {
  entity: EntityViewType;
  children: React.ReactNode;
}) => {
  const { settings } = entity;
  return (
    <div
      className="combo combo-full-screen-container"
      {...DATA_ATTRIBUTES({ settings } as { settings: FullScreenProps })}
    >
      {children}
    </div>
  );
};

const DATA_ATTRIBUTES = ({ settings }: { settings: FullScreenProps }) => ({
  "data-min-height": settings.minHeight,
  "data-horizontal-alignment": settings.horizontalAlignment,
  "data-vertical-alignment": settings.verticalAlignment,
});
